import { InjectedConnector } from '@web3-react/injected-connector';
import { WalletConnectConnector } from '@web3-react/walletconnect-connector';
import { WalletLinkConnector } from '@web3-react/walletlink-connector';

const INFURA_KEY = import.meta.env.VITE_INFURA_KEY;

const injected = new InjectedConnector({
  // TODO: HOTFIX (metamsk calismiyor) kontrol edin
  // asagidaki supportedChainIds verilirse ve metamask baska networke bagli ise pencere cikmiyor. supportedChainIds bos olursa calisiyor.
  // supportedChainIds: [1, 3, 4, 5, 42],
});

const walletConnect = new WalletConnectConnector({
  // rpcUrl: `https://mainnet.infura.io/v3/${INFURA_KEY}`,
  bridge: 'https://bridge.walletconnect.org',
  qrcode: true,
});

const walletlink = new WalletLinkConnector({
  url: `https://mainnet.infura.io/v3/${INFURA_KEY}`,
  appName: 'web3-react-demo',
});

export const connectors = (providers: 'metamask' | 'walletConnect' | 'coinbaseWallet') =>
  ({
    metamask: injected,
    walletConnect,
    coinbaseWallet: walletlink,
  }[providers]);
